// Similar to https://material-ui.com/components/avatars/
import _define_property from "@swc/helpers/src/_define_property.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n			background-color: ",
        ";\n		"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n	width: ",
        "px;\n	height: ",
        "px;\n	position: relative;\n	border-radius: ",
        ";\n	color: ",
        ";\n	background-color: ",
        ";\n	font-weight: ",
        ";\n	font-size: 20px;\n\n	",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n	width: 100%;\n	height: 100%;\n	border-radius: ",
        ";\n	overflow: hidden;\n	text-align: center;\n	display: flex;\n	justify-content: center;\n	align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n	width: 100%;\n	height: 100%;\n	position: absolute;\n	top: 0;\n	left: 0;\n	object-fit: ",
        ";\n	padding: ",
        ";\n	border-radius: ",
        ";\n	filter: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n	width: ",
        "px;\n	height: ",
        "px;\n	position: relative;\n	border-radius: 50%;\n	overflow: hidden;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import styled, { css } from "styled-components";
import { numberInRange } from "~/services/utils/propValidators";
var SHAPES = {
    CIRCLE: "circle",
    SQUARE: "square"
};
var _obj;
var shapeRadiusMap = (_obj = {}, _define_property(_obj, SHAPES.CIRCLE, "50%"), _define_property(_obj, SHAPES.SQUARE, "5%"), _obj);
var Wrap = styled.div.withConfig({
    componentId: "sc-1673965b-0"
})(_templateObject1(), function(props) {
    return props.size;
}, function(props) {
    return props.size;
}, function(props) {
    return shapeRadiusMap[props.shape] || "50%";
}, function(props) {
    return props.theme.colors.text.main;
}, function(props) {
    return !props.hasImage && props.theme.colors.grey[200];
}, function(props) {
    return props.theme.text.fontWeightSemiBold;
}, function(param) {
    var bgColor = param.bgColor;
    return bgColor && css(_templateObject(), bgColor);
});
var InnerCircle = styled.div.withConfig({
    componentId: "sc-1673965b-1"
})(_templateObject2(), function(props) {
    return shapeRadiusMap[props.shape] || "50%";
});
var Image = styled.img.withConfig({
    componentId: "sc-1673965b-2"
})(_templateObject3(), function(props) {
    return props.imageScaleDown ? "scale-down" : "cover";
}, function(props) {
    return props.imageScaleDown && props.imagePadding;
}, function(props) {
    return props.disableImageShape ? "0%" : shapeRadiusMap[props.shape] || "50%";
}, function(props) {
    return props.brightness && "brightness(".concat(props.brightness, ")");
});
var NextImageWrapper = styled.div.withConfig({
    componentId: "sc-1673965b-3"
})(_templateObject4(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
var DEFAULT_PROPS = {
    disableImageShape: false,
    alt: "",
    shape: SHAPES.CIRCLE,
    size: 42
};
var Avatar = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? DEFAULT_PROPS.alt : _alt, bgColor = param.bgColor, brightness = param.brightness, children = param.children, className = param.className, disableImageShape = param.disableImageShape, icon = param.icon, imageScaleDown = param.imageScaleDown, imageDataTestId = param.imageDataTestId, onClick = param.onClick, _shape = param.shape, shape = _shape === void 0 ? DEFAULT_PROPS.shape : _shape, _size = param.size, size = _size === void 0 ? DEFAULT_PROPS.size : _size, src = param.src, text = param.text, NextImage = param.NextImage;
    var innerContent = useMemo(function() {
        if (src) {
            return NextImage ? /*#__PURE__*/ _jsx(NextImageWrapper, {
                size: size,
                children: /*#__PURE__*/ _jsx(NextImage, {
                    src: src,
                    objectFit: "cover",
                    sizes: "".concat(2 * size, "px"),
                    layout: "fill"
                })
            }) : /*#__PURE__*/ _jsx(Image, {
                alt: alt,
                brightness: brightness,
                "data-testid": imageDataTestId,
                disableImageShape: disableImageShape,
                imagePadding: disableImageShape ? "8px" : "5px",
                imageScaleDown: imageScaleDown,
                shape: shape,
                src: src
            });
        }
        if (icon) {
            return icon;
        }
        return text;
    }, [
        NextImage,
        alt,
        brightness,
        disableImageShape,
        icon,
        imageDataTestId,
        imageScaleDown,
        shape,
        size,
        src,
        text, 
    ]);
    return /*#__PURE__*/ _jsxs(Wrap, {
        bgColor: bgColor,
        className: className,
        hasImage: !!src,
        onClick: onClick,
        shape: shape,
        size: size,
        children: [
            /*#__PURE__*/ _jsx(InnerCircle, {
                shape: shape,
                children: innerContent
            }),
            children
        ]
    });
};
Avatar.propTypes = {
    brightness: function(props, propName, componentName) {
        return numberInRange({
            props: props,
            propName: propName,
            componentName: componentName,
            isRequired: false,
            rangeStart: 0,
            rangeEnd: 1
        });
    }
};
Avatar.defaultProps = DEFAULT_PROPS;
export default Avatar;
